import { openFundPage } from "@utils/navigation.util";
import { IFundTagResponse } from "@interfaces/responses.interface";
import { TagWrapper } from "./TagWrapper";
import { TagLabel } from "@ui/Content";
import { cn } from "@utils/tailwind.util";
import { View } from "@ui/View";

interface Props {
  data: IFundTagResponse;
  isDisabled?: boolean;
  onAdd?: (tag: IFundTagResponse) => void;
  onRemove?: (tag: IFundTagResponse) => void;
  withPlusIcon?: boolean;
  iconOnly?: boolean;
}

export function FundTag({
  data,
  isDisabled = false,
  onAdd,
  onRemove,
  withPlusIcon,
  iconOnly,
}: Props) {
  const isClosed = data.object.status === "Closed";

  return (
    <TagWrapper
      data={data}
      isDisabled={isDisabled}
      onRemove={onRemove}
      onRedirect={() => openFundPage(data.object.id)}
      withPlusIcon={withPlusIcon}
      onAdd={onAdd}
    >
      <span
        className={cn(
          "m-1 h-1.5 w-1.5 flex-shrink-0 rounded-full",
          isClosed ? "border-[1.6px] border-content-secondary" : "bg-emerald-700"
        )}
      />

      <View.Condition if={!iconOnly}>
        <TagLabel className="mr-1">{data.object.title}</TagLabel>
      </View.Condition>
    </TagWrapper>
  );
}
